export const AppLinks = {
  recruiter: "https://recruiter.mypiitch.com/login",
  recruiterNew: "https://recruiter.mypiitch.com/",
  android: "https://play.google.com/store/apps/details?id=com.mypiitch.app",
  ios: "https://apps.apple.com/gb/app/mypiitch-app/id1584419673"
};
